import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import 'assets/styles/fieldWork/settings.scss';
import TextField from 'components/form-components/TextField';
import searchIcon from 'assets/images/icons/search.svg';
import arrowsRight from 'assets/images/icons/double-arrow-right.svg';
import arrowsLeft from 'assets/images/icons/double-arrow-left.svg';
import FormButton from 'components/form-components/FormButton';
import FormLoadingButton from 'components/form-components/FormLoadingButton';
import { CallAPI } from 'actions/General';
import { useTranslation } from 'react-i18next';
import { managerSectionPermissionsList } from 'pages/forms/FormPermission/utils';
import SingleRadioBoxField from 'components/form-components/SingleRadioBoxField';

const Records = ({ list, searchName }) => {
  const { t } = useTranslation();
  const filteredListLength = list.filter((x) =>
    x.name?.toLowerCase().includes(searchName?.toLowerCase()),
  ).length;

  const listLength = list.length;

  return (
    <div className='records'>
      {listLength === 0 ? (
        <> {t('text_no_records')}</>
      ) : listLength === filteredListLength ? (
        <>
          {t('text_show_all')} {listLength}
        </>
      ) : (
        <>
          {t('Showing')} {filteredListLength} {t('of')} {listLength}
        </>
      )}
    </div>
  );
};

const Box = ({ list, direction, otherList, setList, setOtherList, name, accessLevelKey }) => {
  const [searchText, setSearchText] = useState('');
  const { t } = useTranslation();
  const handleDragStart = (e, itemData) => {
    e.dataTransfer.setData('text/plain', JSON.stringify(itemData));
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const droppedItemData = e.dataTransfer.getData('text/plain');
    const droppedItem = JSON.parse(droppedItemData);

    let removedFromList = otherList.filter((item) => item.id !== droppedItem.id);
    let addedInList = list;

    if (!list.some((item) => item.id === droppedItem.id)) {
      if (accessLevelKey === 'managerSections' && direction === 'backward') {
        droppedItem['accessLevel'] = 'full_access';
        addedInList = [...list, droppedItem];
      } else addedInList = [...list, droppedItem];
    }
    if (!name) {
      setList(addedInList);
      setOtherList(removedFromList);
    } else if (direction === 'forward') {
      setList(addedInList);
      setOtherList(name, removedFromList);
    } else {
      setList(name, addedInList);
      setOtherList(removedFromList);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
  };

  const moveAll = () => {
    let addedInList = [];

    if (accessLevelKey === 'managerSections' && direction === 'forward') {
      const newList = list.map((element) => ({ ...element, accessLevel: 'full_access' }));
      addedInList = [...otherList, ...newList];
    } else {
      addedInList = [...otherList, ...list];
    }

    if (!name) {
      setList([]);
      setOtherList(addedInList);
    } else if (direction === 'forward') {
      setList([]);
      setOtherList(name, addedInList);
    } else {
      setList(name, []);
      setOtherList(addedInList);
    }
  };

  const moveOne = (itemId) => {
    let removedFromList = list.filter((item) => item.id !== itemId);
    let addedInList = [];
    if (accessLevelKey === 'managerSections' && direction === 'forward') {
      const newList = list
        .filter((item) => item.id === itemId)
        .map((item) => ({ ...item, accessLevel: 'full_access' }));
      addedInList = [...otherList, ...newList];
    } else {
      addedInList = [...otherList, ...list.filter((item) => item.id === itemId)];
    }

    if (!name) {
      setList(removedFromList);
      setOtherList(addedInList);
    } else if (direction === 'forward') {
      setList(removedFromList);
      setOtherList(name, addedInList);
    } else {
      setList(name, removedFromList);
      setOtherList(addedInList);
    }
  };

  const updateAccessLevel = (value, updatedItem) => {
    const updatedItemObj = {
      ...updatedItem,
      accessLevel: value,
    };
    setList(
      list.map((item) => {
        if (item.id === updatedItem.id) return updatedItemObj;
        else return item;
      }),
    );
  };

  return (
    <>
      <TextField
        value={searchText}
        name='search'
        handleChange={(field, value) => {
          setSearchText(value);
        }}
        placeholder={t('field_search')}
        icon={searchIcon}
        shrink
        classes='w-100'
      />
      <div className='sub-card mt-3'>
        <div className='head'>
          <img
            src={direction === 'forward' ? arrowsRight : arrowsLeft}
            className='back-arrow'
            alt='Loading...'
            onClick={moveAll}
          />
        </div>

        <ul onDrop={handleDrop} onDragOver={handleDragOver}>
          {list
            .filter((x) => x.name?.toLowerCase().includes(searchText?.toLowerCase()))
            .map((item, index) => (
              <li
                draggable
                onDragStart={(e) => handleDragStart(e, item)}
                key={index}
                className={
                  accessLevelKey === 'managerSections' && direction === 'backward'
                    ? 'd-flex justify-content-between'
                    : ''
                }
                onClick={() => {
                  moveOne(item.id);
                }}
              >
                <span>{item.name}</span>
                {accessLevelKey === 'managerSections' && direction === 'backward' && (
                  <div className='d-flex gap-2' onClick={(e) => e.stopPropagation()}>
                    {managerSectionPermissionsList.map(({ value, access }, jIndex) => (
                      <SingleRadioBoxField
                        key={item.id + jIndex}
                        name={item.id + jIndex}
                        text={<span>{t(access)}</span>}
                        value={value === item.accessLevel}
                        shrink={true}
                        handleChange={() => {
                          updateAccessLevel(value, item);
                        }}
                        classes='width-max-content'
                      />
                    ))}
                  </div>
                )}
              </li>
            ))}
        </ul>
      </div>
      <Records list={list} searchName={searchText} />{' '}
    </>
  );
};

const SelectionComponent = ({
  title,
  onCancel,
  submit,
  name,
  classes,
  selectedDataList,
  setSelectedList,
  buttonsPosition,
  loading,
  error,
  type,
  showButtons = true,
  accessLevelKey,
}) => {
  const { t } = useTranslation();
  const [unselectedDataList, setUnselectedDataList] = useState([]);
  const [dataList, setDataList] = useState([]);

  const GetAllSearchAbleUser = async () => {
    let callName =
      type === 'groups'
        ? 'GET_ALL_GROUPS'
        : type === 'folders'
        ? 'GET_ALL_FOLDERS'
        : 'GET_ALL_SEARCH_ABLE_USERS';
    let result = await CallAPI(callName, {}, null, null, null, null);
    if (result.status) {
      const apiData = type === 'groups' || type === 'folders' ? result.data : result.data.users;
      setDataList(
        apiData.map((singleRecord) => {
          let name = '';
          if (type === 'groups') name = singleRecord.groupName;
          else if (type === 'folders') name = singleRecord.name;
          else if (type === 'data_source_filter_users')
            name = `${singleRecord.firstName} ${singleRecord.lastName}`;
          else name = `${singleRecord.lastName}, ${singleRecord.firstName}`;
          return {
            id: singleRecord._id,
            name,
          };
        }),
      );
    }
  };

  useEffect(() => {
    GetAllSearchAbleUser();
  }, []);

  useEffect(() => {
    if (dataList.length) {
      const uniqueList = [];
      const unSelectedList = [];
      for (const item of dataList) {
        const match = selectedDataList.find((s) => s.id === item.id);
        if (match) {
          uniqueList.push({
            ...item,
            ...(match.accessLevel ? { accessLevel: match.accessLevel } : {}),
          });
        } else {
          unSelectedList.push({ ...item });
        }
      }
      const isSame =
        uniqueList.length === selectedDataList.length &&
        uniqueList.every((u, i) => u.id === selectedDataList[i]?.id);
      if (!isSame) {
        if (!name) {
          setSelectedList(uniqueList);
        } else {
          setSelectedList(name, uniqueList);
        }
      }
      setUnselectedDataList(unSelectedList);
    }
  }, [dataList, selectedDataList]);

  return (
    <div className={`permissions ${classes}`}>
      <div className='stroke-heading mx-3'>{t(title)}</div>
      <div className='permissions-card row mx-1 my-2 p-3 position-relative'>
        <div className='col-6'>
          <p className='title'>{t('text_not_selected')}</p>

          <Box
            list={unselectedDataList}
            setList={setUnselectedDataList}
            otherList={selectedDataList}
            setOtherList={setSelectedList}
            direction='forward'
            name={name}
            accessLevelKey={accessLevelKey}
          />
        </div>
        <div className='col-6'>
          <div className='d-flex justify-content-between'>
            <p className='title'>{t('text_selected')}</p>
            {showButtons && (
              <div className={`d-flex justify-content-end gap-3 ${buttonsPosition}`}>
                <FormButton text='button_cancel' variant='white-1' onClick={onCancel} />
                <FormLoadingButton
                  text='button_save'
                  variant='green-1'
                  onClick={submit}
                  loading={loading}
                />
              </div>
            )}
          </div>

          <Box
            list={selectedDataList}
            setList={setSelectedList}
            otherList={unselectedDataList}
            setOtherList={setUnselectedDataList}
            direction='backward'
            name={name}
            accessLevelKey={accessLevelKey}
          />
        </div>
      </div>
      {error && <p className='form-field-error my-3'>{t('error ' + error)}</p>}
    </div>
  );
};

SelectionComponent.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  title: PropTypes.string,
  onCancel: PropTypes.func,
  submit: PropTypes.func,
  setSelectedList: PropTypes.func,
  selectedDataList: PropTypes.array,
  classes: PropTypes.string,
  buttonsPosition: PropTypes.string,
  loading: PropTypes.bool,
  showButtons: PropTypes.bool,
  error: PropTypes.string,
  accessLevelKey: PropTypes.string,
};

Records.propTypes = {
  list: PropTypes.array,
  searchName: PropTypes.string,
};

Box.propTypes = {
  list: PropTypes.array,
  direction: PropTypes.string,
  name: PropTypes.string,
  otherList: PropTypes.array,
  setList: PropTypes.func,
  setOtherList: PropTypes.func,
  accessLevelKey: PropTypes.string,
};

export default SelectionComponent;
